export default function () {
  const button = document.getElementById("back-to-top");
  if (button) {
    button.addEventListener("click", (e) => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0; 
      e.preventDefault();   
    })
  } 

}